import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import {
  blogSearchSchema,
  buildBlogListingHead,
  loadBlogListingPage,
} from "@/features/blog/route-data";
import { BlogIndexScreen } from "@/features/blog/screens/BlogIndexScreen";

export const Route = createFileRoute("/_landing/blog/")({
  validateSearch: zodValidator(blogSearchSchema),
  loaderDeps: ({ search }) => search,
  loader: ({ deps }) => loadBlogListingPage("en", deps),
  head: ({ loaderData }) =>
    buildBlogListingHead({
      locale: loaderData?.locale ?? "en",
      availableLocales: loaderData?.availableLocales,
    }),
  component: BlogListingRoute,
});

function BlogListingRoute() {
  return <BlogIndexScreen data={Route.useLoaderData()} />;
}
